module.exports = __webpack_public_path__ + "img/twitter-tweet-5.2ad79064.jpeg";